<template>
  <!-- Topbar -->
  <div class="navbar-light bg-white mb-4 static-top shadow">
    <div class="container-fluid">
      <div class="row align-items-center text-center">
        <!--  Toggle  -->
        <div class="col-6 col-sm-1 d-md-none text-left">
          <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
          </button>
        </div>

        <!-- Date -->
        <div class="d-none d-xl-block col-xl-4">
          <div class="mr-auto ml-md-3 my-2 my-md-0 mw-100">
            <span>{{ current_date }}</span>
          </div>
        </div>

        <!-- Weather -->
        <Weather></Weather>

        <!-- Select Language & User Info -->
        <div class="col-6 col-sm-5 col-md-5 col-lg-6 col-xl-4 d-flex align-items-center justify-content-center">
          <SelectLanguage></SelectLanguage>
          <UserInfo></UserInfo> 
        </div>

      </div>
    </div>
  </div>
  <!-- End of Topbar -->
</template>

<script>
import SelectLanguage from './SelectLanguage.vue'
import Weather from './Weather.vue'
import UserInfo from './UserInfo.vue'
import moment from 'moment'
import "../assets/vendor/bootstrap-select-1.13.9/dist/js/bootstrap-select.min"

export default {
  name: 'TopBar',
  components: {
    SelectLanguage,
    Weather,
    UserInfo
  },
  data(){
    return {
      current_date: null
    }
  },
  mounted: function(){
    this.current_date = moment().format("DD MMMM YYYY [-] dddd")
    $("#sidebarToggleTop").on("click",function(o){
      $("body").toggleClass("sidebar-toggled"); 
      $(".sidebar").toggleClass("toggled"); 
      $(".sidebar").hasClass("toggled") && $(".sidebar .collapse").collapse("hide")
    })
    if(window.innerWidth <= 767) $("#sidebarToggleTop").trigger("click")
  },
  computed: {
    current_lang: function(){
      return this.$i18n.locale
    }
  },
  watch: {
    current_lang: function(){
      this.current_date = moment().format("DD MMMM YYYY [-] dddd")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/vendor/flag-icon-css/css/flag-icon.min.css";
@import "../assets/vendor/bootstrap-select-1.13.9/dist/css/bootstrap-select.min.css";

.navbar-custom {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

nav {
  font-family: 'Roboto Condensed', sans-serif;
}

.pointer {
  cursor:pointer
}

@media only screen and (max-width: 575px) {
  .navbar-light{
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

@media only screen and (max-width: 1366px) {
  h5 > span {
    font-size: 14px;
  }
}

@media only screen and (min-width: 1367px) {
  h5 > span {
    font-size: 18px;
  }
}
</style>
